<template>
    <div>
        <!--
        <v-timeline dense clipped>
            <v-timeline-item v-for="item in b2b.todayLogs"
                             class="mb-3"
                             :color="types[item.Type].color"
                             icon-color="grey lighten-2"
                             small
            >
                <v-layout justify-space-between>
                    <v-flex xs7><h5> {{types[item.Type].title}}</h5>
                        {{item.Text}}
                        <br>
                        <strong>{{getIp(item)}}</strong>
                    </v-flex>
                    <v-flex xs5 text-xs-right>{{item.AddedAt | moment("DD/MM - HH:mm:ss")}}</v-flex>
                </v-layout>
            </v-timeline-item>
        </v-timeline>
        -->
        <log-items :logs="b2b.todayLogs">

        </log-items>
    </div>
</template>

<script>

   /* import StoreState from "@/assets/StoreState";

    export default {
        data: () => ({
            b2b: StoreState.b2b,
            types: {
                'login': {color: 'blue', title: "Άνοιγμα Προσφοράς"},
                'order': {color: 'green', title: "Εκτέλεση Παραγγελίας"}
            }
        }),

        name: "Logs",
        methods: {
            getIp(item) {
                return JSON.parse(item.Value).ip;
            }
    }*/
   import StoreState from "@/assets/StoreState";
   import LogItems from "@/components/LogItems"
   export default {
       data: () => ({
           b2b: StoreState.b2b,
           types: {
               'login': {color: 'blue', title: "Άνοιγμα Προσφοράς"},
               'order': {color: 'green', title: "Εκτέλεση Παραγγελίας"}
           }
       }),

       components:{LogItems},
       name: "Logs",
       methods: {
           getIp(item) {
               return JSON.parse(item.Value).ip;
           }
       }
   }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Logs.vue